import {InputTextV2} from '@prtimes-basis/input';
import {FormField, useFormField} from '../../../form-field';
import styles from './name-field.module.css';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function NameField() {
  return (
    <div className={companyRegistrationPageStyles.nameField}>
      <div className={styles.container}>
        <FormField.Root name='billingInfo.firstName'>
          <label>
            <span>姓</span>
            <Body />
          </label>

          <FormField.Error />
        </FormField.Root>
      </div>

      <div className={styles.container}>
        <FormField.Root name='billingInfo.lastName'>
          <label>
            <span>名</span>
            <Body />
          </label>

          <FormField.Error />
        </FormField.Root>
      </div>
    </div>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return <InputTextV2 required style={{width: '100%'}} {...fieldProps} />;
}
